import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import React, { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { ProcessingStatusContext } from "./ProcessingStatusContext";

export const ProcessingStatusCardImg = () => {
    const toast = useRef(null);
    const { t, i18n } = useTranslation(["processing-status", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const processingStatusContext = useContext(ProcessingStatusContext);
    const { cardImg, setCardImg, processingStatusDialog, setProcessingStatusDialog } = processingStatusContext;

    const hideDialog = () => {
        setProcessingStatusDialog(false);
    };
    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={processingStatusDialog} style={{ width: "90%" }} header={t("processing-status.viewCardImg")?.toUpperCase()} modal className="p-fluid text-center" onHide={hideDialog}>
                <div className="formgrid">
                    <div className="grid text-left mt-2">
                        <div className="col-6">
                            <BlockDetail title={t("processing-status.fontImage")}>
                                <img src={`data:image/jpeg;base64,${cardImg?.fontImage}`} width="100%" height={"300px"} alt=""></img>
                            </BlockDetail>
                        </div>
                        <div className="col-6">
                            <BlockDetail title={t("processing-status.backImage")}>
                                <img src={`data:image/jpeg;base64,${cardImg?.backImage}`} width="100%" height={"300px"} alt=""></img>
                            </BlockDetail>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    );
};
